import { Injectable, signal } from '@angular/core';

export type CookieConsentChoice = 'accepted' | 'essential';

const STORAGE_KEY = 'karibuu_cookie_consent';

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
  readonly choice = signal<CookieConsentChoice | null>(this.readStoredChoice());

  hasChoice(): boolean {
    return this.choice() != null;
  }

  acceptAll(): void {
    this.persist('accepted');
  }

  acceptEssential(): void {
    this.persist('essential');
  }

  private persist(choice: CookieConsentChoice): void {
    if (typeof localStorage !== 'undefined') {
      try {
        localStorage.setItem(STORAGE_KEY, choice);
      } catch {
        /* ignore quota / private mode */
      }
    }
    this.choice.set(choice);
  }

  private readStoredChoice(): CookieConsentChoice | null {
    if (typeof localStorage === 'undefined') {
      return null;
    }
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw === 'accepted' || raw === 'essential') {
        return raw;
      }
    } catch {
      /* ignore */
    }
    return null;
  }
}
